import { render, staticRenderFns } from "./Dependency.vue?vue&type=template&id=6ae8b63b&"
import script from "./Dependency.vue?vue&type=script&lang=js&"
export * from "./Dependency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports